import { Component } from 'solid-js';

export interface LineWeightIconProps {
  size?: string;
  class?: string;
}

/**
 * Line weight icon component showing horizontal lines of varying thickness.
 * This represents the concept of line weight/thickness in CAD applications.
 */

export const LineWeightIcon: Component<LineWeightIconProps> = (props) => {
  return (
    <svg
      class={`flex align-center justify-center my-auto ${props.class || ''}`}
      width={props.size || '20'}
      height={props.size || '20'}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6291_23710)">
        <path
          d="M2.44238 9.91732H12.9424V8.75065H2.44238V9.91732ZM2.44238 11.6673H12.9424V11.084H2.44238V11.6673ZM2.44238 7.58398H12.9424V5.83398H2.44238V7.58398ZM2.44238 2.33398V4.66732H12.9424V2.33398H2.44238Z"
          fill="#363545"
        />
      </g>
      <defs>
        <clipPath id="clip0_6291_23710">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0.692383)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
